import React, { Component } from "react";
import { connect } from "react-redux";
import { openTrackModal, deleteTrack } from "ContentActions";
import { checkContentDashboardStatus } from "GeneralTabAction";
import { showError, showSuccess } from "ReduxErrorBar";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import LocaleStrings from "Languages";

class ScheduleTrackTitle extends Component {
  onEditTrackClick() {
    this.props.openTrackModal(true, this.props.track);
  }

  onDeleteTrack() {
    confirmAlert({
      title: "Delete",
      message: "This will permanently delete the Track and Sessions. Continue?",
      confirmLabel: "OK",
      cancelLabel: "CANCEL",
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            this.props.deleteTrack(
              this.props.session,
              this.props.track,
              (result) => {
                if (result.error) {
                  this.props.showError("Delete failed due to error!");
                } else {
                  this.props.showSuccess("Track deleted successfully!");
                  this.props.checkContentDashboardStatus(this.props.session);
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  }

  render() {
    return (
      <th className="schedule-table-header-th">
        <div className="track-delete">
          <div
            className="track-icon"
            onClick={this.onEditTrackClick.bind(this)}
          >
            <img src="../../style/images/edit-icon-small.png" />
          </div>
          <div className="track-icon" onClick={this.onDeleteTrack.bind(this)}>
            <img
              style={{ marginTop: "5px" }}
              src="../../style/images/delete-icon-grey.png"
            />
          </div>
        </div>
        <div className="track-title">
          <span>{this.props.track.trackname}</span>
        </div>
      </th>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
  };
}

export default connect(mapStateToProps, {
  openTrackModal,
  deleteTrack,
  showSuccess,
  showError,
  checkContentDashboardStatus,
})(ScheduleTrackTitle);
